import { useMemo } from 'react';
import { renderMarkdown } from '@suangua/shared';

/**
 * Markdown 安全渲染（PLAN §6.2：markdown-it + sanitize，服务端同一实现）
 * md-body 类与原型样式（.md-body）对齐：鎏金强调色 / 引用块 / 行内代码。
 * 内容已在 renderMarkdown 内转义，此处仅注入 HTML。
 */
export function MarkdownView({ content, className = '' }: { content: string; className?: string }) {
  const html = useMemo(() => renderMarkdown(content), [content]);
  return <div className={`md-body ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
